<template>
    <employees-show-page parent v-slot:default="_parent">
        <sub-item-show-view v-slot:default="_">
            <employee-transaction-edit-form :disabled="_.itemDisabled" v-model="_.item" :employee="_parent.item" />
        </sub-item-show-view>
    </employees-show-page>
</template>

<script>
    import EmployeesShowPage from '../../show'
    import SubItemShowView from '../../../../Item/Views/SubItemShowView'
    import EmployeeTransactionEditForm from './Shared/EmployeeTransactionEditForm'

    export default {
        name: 'EmployeesShowTransactionsEditPage',
        inheritAttrs: false,
        components: {
            EmployeesShowPage,
            SubItemShowView,
            EmployeeTransactionEditForm,
        },
    }
</script>

<style scoped>

</style>